import "./Modal.styles.scss";
import React, { useRef } from "react";
import { CSSTransition } from "react-transition-group";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  overlayExtraClass?: string;
  innerExtraClass?: string;
}

const Modal = ({
  isOpen,
  onClose,
  children,
  overlayExtraClass,
  innerExtraClass,
}: ModalProps) => {
  const nodeRef = useRef(null);
  const innerRef = useRef(null);

  return (
    <>
      <CSSTransition
        nodeRef={nodeRef}
        in={isOpen}
        timeout={300}
        classNames="overlay"
        unmountOnExit
      >
        <div
          ref={nodeRef}
          className={`local-modal-overlay ${overlayExtraClass || ""}`}
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
          onKeyDown={(e) => {
            e.stopPropagation();
            onClose();
          }}
          role="button"
          tabIndex={0}
        />
      </CSSTransition>
      <CSSTransition
        nodeRef={innerRef}
        in={isOpen}
        timeout={300}
        classNames="animated-modal"
        unmountOnExit
      >
        <div
          ref={innerRef}
          className={`local-modal-inner ${innerExtraClass || ""}`}
        >
          {children}
        </div>
      </CSSTransition>
    </>
  );
};

export default Modal;
